import { useContext, useMemo } from 'react';
import { AppContext } from '@rabbit/app-context';
import { LIST_CURRENCIES } from '@rabbit/bizproc/react';

export function useTenantCurrencies() {
  const { tenantInfo } = useContext(AppContext);
  const currency = tenantInfo?.currency ?? 'GBP';
  const allowedCodes =
    (tenantInfo?.allowedCurrencies && tenantInfo.allowedCurrencies.length > 0
      ? tenantInfo.allowedCurrencies
      : LIST_CURRENCIES.map((c) => c.code)) || LIST_CURRENCIES.map((c) => c.code);

  const allowedCurrencies = useMemo(
    () => LIST_CURRENCIES.filter((c) => allowedCodes.includes(c.code)),
    [allowedCodes]
  );

  return { currency, allowedCodes, allowedCurrencies };
}

export default useTenantCurrencies;


